module.exports = __webpack_public_path__ + "923b709fc9ee0c1a560a1bf3b2bd0e21.png";